import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import ttsAudio from "../assets/sound/tts_05.mp3"; // mp3 경로 import

const About2 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { sex } = useParams();
    const { birth } = useParams();


    const [tody,SetToday]=useState();

    const audioRef = useRef(null);

    const clickNext= item => {

        navigate('/about3/'+name+'/'+sex+'/'+birth+'/'+item);
    };
    
    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />

            <div className="input-area">
                <div className="step_area">
                    STEP 4
                </div>
                <div className="title_area">
                    <h1 className="num_title">(4/4)</h1>
                    <h2 className="title">오늘의 기분을 선택해주세요</h2>
                </div>

                <div className="input_section" style={{background:"#ffffff"}}>
                    <div className="flex_area">
                        <ul>
                            <li>
                                <button className="checkBtn good" onClick={() => clickNext('1')}></button>
                            </li>
                            <li>
                                <button className="checkBtn normal" onClick={() => clickNext('2')}></button>
                            </li>
                            <li>
                                <button className="checkBtn bad" onClick={() => clickNext('3')}></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About2;
